import { SidebarComponent } from './sidebar/sidebar.component';
import { SidebarItemComponent } from './sidebar-item/sidebar-item.component';

export const Components = [
	SidebarComponent,
	SidebarItemComponent,
];
